import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { theme } from '../../styles/theme';

interface DrawerToggleProps {
  $isOpen: boolean;
  onClick: () => void;
  children: ReactNode;
}

export const DrawerToggle: FC<DrawerToggleProps> = ({
  $isOpen,
  onClick,
  children,
}) => (
  <Box
    component="button"
    onClick={onClick}
    sx={{
      position: 'absolute',
      left: $isOpen ? theme.layout.drawerWidth : '0',
      top: '50%',
      transform: 'translateY(-50%)',
      width: theme.spacing(10),
      height: theme.spacing(20),
      background: theme.colors['green-100'],
      border: 'none',
      borderRadius: `0 ${theme.spacing(2)} ${theme.spacing(2)} 0`,
      boxShadow: `${theme.spacing(0.5)} 0 ${theme.spacing(
        1,
      )} rgba(0, 0, 0, 0.15)`,
      cursor: 'pointer',
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: theme.fontSizes.h3,
      zIndex: 1000,
      transition: 'all 400ms ease-in-out',
      '&:hover': {
        background: theme.colors['green-80'],
      },
      [`@media (min-width: ${theme.breakPoints.desktop}px)`]: {
        display: 'flex',
      },
    }}
  >
    {children}
  </Box>
);
